import React, { useEffect, useState } from "react";
import Modal from "../../shared/Modal";
import CustomButton from "../../shared/CustomButton";
import InputKeyValue from "../../shared/InputKeyValue";
import KeyDropdownValue from "../../shared/KeyDropdownValue";
import { CircleWarning, CloseMD } from "../../normalizer";

const Popup = ({
  Condition,
  Response,
  isOpenValue,
  Title,
  clearVariables,
  CampaignCards,
  Selected,
  ToExcute,
  Value,
  Value_,
  ToChangeValue,
  ToChangeValue_,
  EventType,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenValue);
  const [wrongAtempt, setWrongAtempt] = useState(false);
  const [currentText, setCurrentText] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [Comfirmed, setComfirmed] = useState(false);
  // Controls the inline T&C / agreement_text popup
  const [showAgreement, setShowAgreement] = useState(false);

  useEffect(() => {
    if (EventType == "Register") {
      setIsValid(Value_ && Value && isTermsAccepted);
    } else if (EventType == "Charge") {
      // Charge requires an amount, the card number for confirmation, and T&C
      setIsValid(!!(Value && currentText && isTermsAccepted));
    } else if (EventType == "Cancel") {
      // Cancel only requires the card number for confirmation (no T&C)
      setIsValid(!!(currentText));
    } else if (EventType == "View") {
      setIsValid(true);
    }
  }, [Value_, Value, isTermsAccepted, currentText]);

  useEffect(() => {
    check();
  }, []);

  function ChangeValue(input) {
    ToChangeValue(input);
  }

  function ChangeValue_(input) {
    ToChangeValue_(input.name);
  }

  function Comfirm() {
    if (EventType == "Register") {
      ToExcute();

      WaitToClose();
    } else {
      if (currentText == Selected.number) {
        ToExcute();

        WaitToClose();
      } else {
        setWrongAtempt(true);
      }
    }
  }

  function Close() {
    Condition(false);
    Selected = null;
    clearVariables();
    window.location.reload();
  }

  function WaitToClose() {
    setComfirmed(true);
  }

  // JNS: Not really sure of the purpose of this.
  function check() {
    var input = document.querySelectorAll("input");
    for (var i = 0; i < input.length; i++) {
      const placeholder = input[i].getAttribute("placeholder");
      input[i].setAttribute("size", placeholder ? placeholder.length : 0);
    }
  }

  // ── Agreement text helper ─────────────────────────────────────────────────
  // Returns the HTML agreement text for the card type relevant to this popup.
  function getAgreementText() {
    if (EventType === "Register") {
      const card = CampaignCards && Value_
        ? CampaignCards.find((c) => c.card_type.name === Value_)
        : null;
      return (card && card.card_type && card.card_type.agreement_text) || "";
    }
    return (Selected && Selected.card_type && Selected.card_type.agreement_text) || "";
  }

  // ── Body content per event type ────────────────────────────────────────────

  function getBodyForCharge() {
    const options = Selected.recharge_options.map((card) => ({
      value: card.value,
      label: `Carregamento ${card.value}€ - ${card.points} pontos`,
    }));
    const numberLabel = (Selected.card_type && Selected.card_type.number_label) || "Número do cartão";
    return (
      <>
        <p className="card-popup-charge__subtitle">
          Escolha o valor a carregar e aceite os termos e condições para
          concluir o carregamento.
        </p>
        {wrongAtempt && (
          <p className="card-popup-charge__error">
            Número do cartão está errado!
          </p>
        )}
        <div className="card-popup-charge__form">
          {/* Card number required to confirm ownership before charging */}
          <InputKeyValue
            className="card-popup-charge__input"
            title={numberLabel}
            placeholder="Inserir número do cartão"
            value={currentText}
            onChange={(e) => setCurrentText(e.target.value)}
          />
          {/* menuPortalTarget renders the list at <body> level to escape the    */}
          {/* modal's overflow clipping; styles.menuPortal bumps the z-index     */}
          {/* above the modal backdrop (1001) so the list is actually visible.   */}
          <KeyDropdownValue
            className="card-popup-charge__select"
            id="Card"
            title="Valor a carregar"
            name="breed"
            defaultValue={Value}
            options={options}
            optionsId="value"
            optionsLabel="label"
            placeholder="0,00€"
            onChange={(e) => ToChangeValue(e.value)}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: function(base) { return Object.assign({}, base, { zIndex: 9999 }); } }}
          />
        </div>
      </>
    );
  }

  function getBodyForCancel() {
    const numberLabel = (Selected && Selected.card_type && Selected.card_type.number_label) || "Número do cartão";
    return (
      <>
        <div className="gl2026-modal__callout gl2026-modal__callout--transparent">
          <div className="gl2026-modal__callout-content">
            <p className="gl2026-modal__callout-text">
              A eliminação do cartão implica a perda definitiva do valor carregado.
            </p>
            <p className="gl2026-modal__callout-text">
              Esta ação não pode ser desfeita. Confirma que deseja eliminar o cartão?
            </p>
          </div>
        </div>
        {/* Card number required to confirm the user knows which card they're cancelling */}
        {wrongAtempt && (
          <p className="card-popup-charge__error">
            Número do cartão está errado!
          </p>
        )}
        <InputKeyValue
          className="card-popup-cancel__input"
          title={`Confirme o ${numberLabel.toLowerCase()}`}
          placeholder="Inserir número do cartão"
          value={currentText}
          onChange={(e) => setCurrentText(e.target.value)}
        />
      </>
    );
  }

  function getBodyForRegister() {
    const selectedCard = CampaignCards
      ? CampaignCards.find((card) => card.card_type.name === Value_)
      : null;

    const cardLabel =
      selectedCard && selectedCard.card_type
        ? selectedCard.card_type.number_label
        : "Número do cartão";

    const cardTypes = CampaignCards
      ? CampaignCards.map((card) => card.card_type)
      : [];

    return (
      <>
        <p className="card-popup-register__subtitle">
          Selecione o tipo e indique o número do cartão para adicionar à sua conta.
        </p>
        {wrongAtempt && (
          <p className="card-popup-register__error">Cartão não existe!</p>
        )}
        <div className="card-popup-register__form">
          <KeyDropdownValue
            className="card-popup-register__select"
            title="Tipo de cartão"
            name="CardsType"
            defaultValue={Value_}
            options={cardTypes}
            placeholder="Selecione"
            optionsId="name"
            optionsLabel="name"
            onChange={(e) => ChangeValue_(e)}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: function(base) { return Object.assign({}, base, { zIndex: 9999 }); } }}
          />
          <InputKeyValue
            className="card-popup-register__input"
            id="location"
            title={cardLabel}
            placeholder="Inserir número"
            value={Value}
            onChange={(e) => ChangeValue(e.target.value)}
          />
        </div>
      </>
    );
  }

  return (
    <>
    <Modal show={isOpen} untoggle={Close} large>
      {/* Header — Cancel: icon+close on row 1, title on row 2. Other types: title + close in a single row */}
      {EventType === "Cancel" ? (
        <div className="gl2026-modal__header gl2026-modal__header--cancel noborder">
          <div className="gl2026-modal__header-toprow">
            <CircleWarning className="card-popup-cancel__warning" />
            <button
              type="button"
              className="gl2026-modal__close"
              onClick={Close}
              aria-label="Fechar"
            >
              <CloseMD />
            </button>
          </div>
          {Title && <h4 className="gl2026-modal__title">{Title}</h4>}
        </div>
      ) : (
        <div className="gl2026-modal__header noborder">
          {Title && <h4 className="gl2026-modal__title">{Title}</h4>}
          <button
            type="button"
            className="gl2026-modal__close"
            onClick={Close}
            aria-label="Fechar"
          >
            <CloseMD />
          </button>
        </div>
      )}

      {/* Body */}
      <div className="gl2026-modal__body">
        {EventType === "Charge"
          ? getBodyForCharge()
          : EventType === "Register"
          ? getBodyForRegister()
          : EventType === "Cancel"
          ? getBodyForCancel()
          : null}

        {/* Feedback messages after action */}
        {/* Note: Response is passed as an integer (0 / 200 / -1) from CardTable.
            Use Number() to normalise before strict comparison. */}
        {Number(Response) === 200 && Comfirmed && (
          <div className="gl2026-modal__alert gl2026-modal__alert--success">
            Efetuado com sucesso!
          </div>
        )}
        {Number(Response) !== 200 && Comfirmed && (
          <div className="gl2026-modal__callout gl2026-modal__callout--warning">
            <div className="gl2026-modal__callout-content">
              <p className="gl2026-modal__callout-text">
                Não foi possível efetuar a operação com sucesso.
              </p>
            </div>
          </div>
        )}

        {/* Terms acceptance — not shown for Cancel flow */}
        {EventType !== "Cancel" && !Comfirmed && (
          <div className="card-popup-terms">
            <InputKeyValue
              className="card-popup-terms__checkbox"
              type="checkbox"
              onChange={(e) => setIsTermsAccepted(e.target.checked)}
            />
            <div className="card-popup-terms__content">
              <p className="card-popup-terms__text">
                Li e aceito os{" "}
                {/* Open the card type's agreement_text inline instead of
                    navigating to /supporting-documents */}
                <button
                  type="button"
                  className={"card-popup-terms__link" + (EventType === "Register" && !Value_ ? " card-popup-terms__link--disabled" : "")}
                  disabled={EventType === "Register" && !Value_}
                  onClick={() => setShowAgreement(true)}
                >
                  Termos e Condições
                </button>{" "}
                aplicáveis.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="gl2026-modal__footer">
        {(Number(Response) === 0 || Number(Response) === -1) && (
          <CustomButton secondary type="button" onClick={Close}>
            Cancelar
          </CustomButton>
        )}
        {(Number(Response) === 0 || Number(Response) === -1) && (
          <CustomButton type="button" disabled={!isValid} onClick={Comfirm}>
            Confirmar
          </CustomButton>
        )}
        {Number(Response) === 200 && Comfirmed && (
          <CustomButton type="button" onClick={Close}>OK</CustomButton>
        )}
      </div>
    </Modal>

    {/* ── Agreement text popup ─────────────────────────────────────────────── */}
    {/* Rendered AFTER the main modal so it sits later in the DOM and wins the  */}
    {/* z-index tie (both use gl2026-modal__dialog at z-index 1001).            */}
    {showAgreement && (
      <Modal show={showAgreement} untoggle={() => setShowAgreement(false)} large>
        <div className="gl2026-modal__header">
          <h4 className="gl2026-modal__title">Termos e Condições</h4>
          <button
            type="button"
            className="gl2026-modal__close"
            onClick={() => setShowAgreement(false)}
            aria-label="Fechar"
          >
            <CloseMD />
          </button>
        </div>
        <div className="gl2026-modal__body">
          <div
            className="gl2026-modal__terms"
            dangerouslySetInnerHTML={{ __html: getAgreementText() }}
          />
        </div>
        <div className="gl2026-modal__footer">
          <CustomButton type="button" onClick={() => setShowAgreement(false)}>OK</CustomButton>
        </div>
      </Modal>
    )}
    </>
  );
};

export default Popup;
